import { CircularProgress } from "@mui/material";
import React from "react";

const Spinner = () => {
  return (
    <div className="m-auto">
      <CircularProgress color="inherit" />
    </div>
  );
};

export default Spinner;
